// extracted by mini-css-extract-plugin
export var about = "container-module--about--6fpyv";
export var imageTextModuleModern = "container-module--image-text-module--modern--2NtO0";
export var nonAbout = "container-module--nonAbout--Ivd5n";
export var root = "container-module--root--59bDI";